export const tnc = {
  myntra: (
    <ol className="list-disc pl-6">
      <li>
        Flat Rs.400 off on min buy of Rs.1999 (Valid on select styles) on Myntra
        app or website, valid till 31st December 2023.
      </li>
      <li>Valid only on a selected catalogue listed in the redemption link.</li>
      <li>The code can be used once per Customer.</li>
      <li>
        This offer is not valid at any of the alliance partner retail
        outlets/stores.
      </li>
      <li>Multiple coupons cannot be clubbed in a single order.</li>
      <li>
        The balance amount, after the discount is availed, will have to be paid
        by the customer at the time of purchase.
      </li>
      <li>
        In no case, whatsoever, can the discount amount be refunded, encashed,
        or partly encashed.
      </li>
      <li>
        Return and Exchange Policy offers you the option to return or exchange
        items purchased on Myntra, application within 30 days of the receipt. In
        case of return of the purchased item, please refer to the “Return
        Policy” on the website/app or call Myntra Customer care.
      </li>
      <li>
        All orders would be subject to availability at the time of purchase and
        will be governed by the standard terms and conditions listed on the App.
      </li>
      <li>
        All disputes arising out of or in connection to this scheme are subject
        to exclusive jurisdiction of the courts in Bangalore only.
      </li>
      <li>
        Disclaimers: Company is not responsible for any typographical error
        leading to an invalid coupon.
      </li>
      <li>For any coupon related queries call: 080 6156 1999.</li>
    </ol>
  ),
  yatra: (
    <ol className="list-disc pl-6">
      <li>Offer validity: 31st Dec, 2023</li>
      <li>Hotel discounts will be valid on selected hotels only.</li>
      <li>
        Offer valid once per user, per product, per month during the offer
        period.
      </li>
      <li>Valid on bookings made during offer duration only.</li>
      <li>This offer is valid only on online confirmed bookings.</li>
      <li>
        Yatra reserves the right to withdraw, modify or replace this offer
        without prior notice and the same is at the sole discretion of the
        company.
      </li>
      <li>This offer cannot be combined with any other offer/scheme.</li>
      <li>
        By availing this offer, it is deemed that the customer has agreed to all
        the terms and conditions mentioned herein.
      </li>
    </ol>
  ),
  swiggy: (
    <ol className="list-disc pl-6">
      <li>
        The discount coupon code is applicable only on Swiggy Gourmet
        restaurants on a minimum order value of Rs 799
      </li>
      <li>
        Swiggy gourmet restaurants are available in Mumbai, Delhi NCR,
        Bengaluru, Pune, Hyderabad, Chennai, Kolkata, Ahmedabad, Jaipur,
        Chandigarh, and Goa
      </li>
      <li>
        The coupon has to be redeemed within the validity period. Codes cannot
        be used once expired
      </li>
      <li>
        The discount coupon code is applicable only once per user every month
      </li>
      <li>
        The discount is applicable only to the price of the items ordered. It is
        not applicable on taxes, delivery charges, and packaging charges that
        are applicable to the cart
      </li>
      <li>
        The maximum discount applicable is equivalent to the value of the
        discount coupon code. The coupon cannot be clubbed with any other offer
        on the app
      </li>
      <li>
        Reach out to{' '}
        <a href="mailto: support.officeperks@swiggy.in">
          support.officeperks@swiggy.in
        </a>{' '}
        for 24/7 support in case of redemption-related issues
      </li>
      <li>
        For issues related to orders, reach out to the “Help” section on the
        Swiggy app for 24/7 customer support
      </li>
      <li>
        Other TnCs may apply. Please refer to{' '}
        <a href="https://www.swiggy.com/tnc-corporate-discount">
          https://www.swiggy.com/tnc-corporate-discount
        </a>
      </li>
    </ol>
  ),
  ixigo: (
    <ol className="list-disc pl-6">
      <li>No Minimum booking amount.</li>
      <li>Valid once per user.</li>
      <li>Valid for every user.</li>
      <li>Validity till 31st Aug 2023.</li>
      <li>Valid for both domestic & international flights.</li>
      <li>Convenience fees will be charged as per the applicability.</li>
      <li>
        The offer is valid for bookings made on ixigo website Mobile site,
        Android & IOS App.
      </li>
      <li>
        The offer cannot be clubbed with any other offer running on ixigo.
      </li>
      <li>
        In case of partial/full cancellation, the offer stands void and discount
        will be rolled back before processing the refunds.
      </li>
      <li>
        Child/infant discount, date or refund charges, weekend surcharge,
        blackout period will also be applicable as per the fare rule.
      </li>
      <li>Changes in the names are not allowed.</li>
      <li>
        In the event of any misuse or abuse of the offer, ixigo reserves the
        right to deny the offer to the customers.
      </li>
      <li>Ixigo is the sole authority for interpretation of these terms.</li>
      <li>
        In addition, Ixigo standard booking and privacy policy on ixigo.com
        shall apply.
      </li>
      <li>
        Ixigo reserves the right, at any time, without prior notice and
        liability and without assigning any reason whatsoever, to
        add/alter/modify/change or vary all of these terms and conditions or to
        replace, wholly or in part, this offer by another offer, whether similar
        to this offer or not, to extent or withdraw it altogether.
      </li>
      <li>
        Ixigo shall not be liable for any loss or damage arising due to force
        majeure.
      </li>
    </ol>
  ),
};
